import React, { memo } from 'react';
import { isEqual } from 'src/utils/lodash-alternatives';
import {
  AccordionButton,
  useAccordionContext,
  useAccordionItemContext,
} from '@reach/accordion';
import cx from 'clsx';
import styles from '../MainNavigation.module.scss';
import { MinusIcon, PlusIcon } from '../../../../components/icons';

interface AnimatedAccordionButtonProps {
  isActive?: boolean;
  hideExpandButton: boolean;
}

const AnimatedAccordionButton: React.FC<AnimatedAccordionButtonProps> = memo(
  ({ isActive, hideExpandButton }) => {
    let { isExpanded } = useAccordionItemContext();
    let { openPanels } = useAccordionContext();
    const loadingAnimation = isExpanded && openPanels.length > 0;

    return (
      <AccordionButton
        className={cx(styles.accordionButton, styles.accordionButtonIcon)}
      >
        {!hideExpandButton ? (
          <>
            <MinusIcon
              className={cx(
                styles.accordionIcon,
                isActive && styles.accordionIconActive,
                loadingAnimation ? styles.expandMinus : styles.hideMinus
              )}
            />
            <PlusIcon
              className={cx(
                styles.accordionIcon,
                isActive && styles.accordionIconActive,
                loadingAnimation ? styles.collapsePlus : styles.showPlus
              )}
            />
          </>
        ) : null}
      </AccordionButton>
    );
  },
  (
    prevProps: AnimatedAccordionButtonProps,
    nextProps: AnimatedAccordionButtonProps
  ) => isEqual(prevProps, nextProps)
);

export default AnimatedAccordionButton;
